import { component } from 'picoapp';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Ready from 'utils/ready';

export default component(async (node) => {
  gsap.registerPlugin(ScrollTrigger);

  // Force at start, to prevent gsap to bug out
  Ready(() => setTimeout(() => window.scrollTo(0, 0), 1));

  const initDateTimeline = () => {
    const timeline = node.querySelector('[data-timeline-navigation]');
    const timelineTriggers = timeline.querySelectorAll('a[href*="#"]');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const id = entry.target.getAttribute('id');

          timelineTriggers.forEach((trigger) => {
            trigger.parentElement.classList.remove('is-active');

            if (trigger.getAttribute('href') === `#${id}`) {
              trigger.parentElement.classList.add('is-active');
            }
          });
        }
      });
    });

    timelineTriggers.forEach((trigger) => {
      const target = document.querySelector(`[id="${trigger.getAttribute('href').replace('#', '')}"]`);
      observer.observe(target);

      trigger.addEventListener('click', (event) => {
        event.preventDefault();

        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
          });
        }
      });
    });
  }

  initDateTimeline();
});
